import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { IMyDpOptions, IMyDate ,IMyDateModel} from 'mydatepicker';
//import { Angular2CsvModule } from 'angular2-csv';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { Http, Headers, Response, RequestOptions } from  '@angular/http';
//import { Angular2Csv } from 'angular2-csv';
@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css'],
  providers: [SharedService]
})
export class TransactionsComponent implements OnInit {
   myDatePickerOptions: IMyDpOptions = {
      // other options...
      dateFormat: 'yyyy/mm/dd',
      alignSelectorRight: true,
      showTodayBtn: false,
      
  };

   myDatePickerOptionsend: IMyDpOptions = {
      // other options...
      dateFormat: 'yyyy/mm/dd',
      alignSelectorRight: true,
      showTodayBtn: false,
       
  };

  advertiserNameSearch:any = '';
  campaignType:any = 0;
  startDate:any = '';
  endDate:any = '';
  downloadTransactionIds:any=[];
  downloadExcelData:any=[];
  pdfFlag:boolean=true;
  excelFlag : boolean = true;
      transactionForm:FormGroup;
    selectedAud : any;
Alldata : any;
  searchBtn:boolean=true;
  downloadBtn:boolean=true;
  nameSortText:string='MCE.name';
  dateSortText:string='transactionDate';
  data = [];
  itemsTotalAdv = 0;
  page = 1;
  searchSegText = '';
  objLoaderStatus: boolean = false;
  errormessage = '';
  charFlag: boolean = false;
  message = "";
  searchmessage = "";
  disabledCheckValue =[];

  column = "";
  numberColumn: number = 0;
  order: string = "ASC";
  sortingOrder = [];
  constructor(private localstorage: LocalStorage,
      private loaderService: LoaderService,
      private formBuilder: FormBuilder,
      private shareService: SharedService,
      private dialogService: DialogService) {

      var i = 0;
      for (i = 0; i < 3; i++) {
          this.sortingOrder[i] = true;
      }

      this.transactionForm = this.formBuilder.group({
     
       transactions :['']
    });
  }

  ngOnInit() {

    var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 

      this.loaderService.loaderStatus.subscribe((val: boolean) => {
          this.objLoaderStatus = val;
      });
      this.localstorage.setStorage("country", '');
      var token = this.localstorage.getStorage("token");
      this.loaderService.displayLoader(true);
      this.shareService.CallDatawithToken("admin/getAllTransactions?currentSize=25&sortColumn=MCE.name&sortOrder=ASC", null, token).subscribe((result) => {
          console.log(result.data);
          var i=0;
          if (result.data) {
              this.data = result.data;
              for(i=0;i<this.data.length;i++){
                 this.data[i].amountDeducted = (Math.round( this.data[i].amountDeducted * 100) / 100).toFixed(2);
       
              }
              this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
              this.loaderService.displayLoader(false);

          }
      });
  }
  allTransaction() {
    this.page = 1;
    this.errormessage = "";
    this.searchmessage = "";
    this.selectedAud = "";
    this.advertiserNameSearch = '';
    this.itemsTotalAdv = 0;
    this.pdfFlag = true;
    this.excelFlag = true;
    this.searchBtn = true;
    var token = this.localstorage.getStorage("token");
    this.loaderService.displayLoader(true);
    var i = 0;
    for (i = 0; i < 3; i++) {
      this.sortingOrder[i] = true;
    }
    this.campaignType = 0;
    this.startDate = '';
    this.endDate = '';
    this.column = "";
    this.shareService.CallDatawithToken("admin/getAllTransactions?currentSize=25&sortColumn=MCE.name&sortOrder=ASC", null, token).subscribe((result) => {
      console.log(result.data);
      if (result.data) {
          this.downloadTransactionIds = [];
        this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
               this.loaderService.displayLoader(false);
        this.dataModulation();

      }
    });
  }


  nextTransaction(text, id, order, event) {
      var order;
      this.column="";
      if (text) {
          this.column = text;
      }
      if (id !== '') {
          this.numberColumn = id;
      }
      var advertiserName = '';

      var i = 0;
      for (i = 0; i < 6; i++) {
          if (this.numberColumn != i) {
              this.sortingOrder[i] = true;
          }
      }
            advertiserName = this.advertiserNameSearch.trim();

      if (order) {
          this.order = order;
      }
      if (this.column == "") {
                if (advertiserName == '' || advertiserName == undefined) {
          this.column = "MCE.name";
                }
                else{
        this.column="CM.name";

                }
  }
     if (this.order == 'DESC') {
          this.sortingOrder[this.numberColumn] = false;
      } else {
          this.sortingOrder[this.numberColumn] = true;
      }
      //Serach section
      var startDate='';
      var endDate='';
      var type=0;
    
      if(this.startDate!=null) {
      if(this.startDate.formatted==undefined || this.startDate.formatted==undefined){
          startDate='';
        } else {
          startDate="&startAt="+this.startDate.formatted;
        }
      }
      if(this.endDate!=null) {
        if(this.endDate.formatted==undefined || this.endDate.formatted==undefined){
          endDate='';
        } else {
          endDate="&endAt="+this.endDate.formatted;
        }
      }
      type=this.campaignType;
    
      //End search section
      
      this.itemsTotalAdv = 0;
      var j = 0;
      this.page = event;
      this.errormessage = "";
      this.searchmessage = "";
      var token = this.localstorage.getStorage("token");
      if (advertiserName == '' || advertiserName == undefined) {
        this.nameSortText='MCE.name';
        this.dateSortText='transactionDate';
      } else {
        this.nameSortText='CM.name';
        this.dateSortText='transaction_date';
      }
      this.loaderService.displayLoader(true);
        this.shareService.CallDatawithToken("admin/getAllTransactions?currentSize=25&currentPage=" + event + "&sortColumn=" + this.column + "&sortOrder=" + this.order+"&q="+advertiserName+"&type="+type+startDate+endDate, null, token).subscribe((result) => {
              console.log(result.data);
              if (result.data) {
                  this.data = result.data;
                  this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
              
                        this.dataModulation();
                           this.loaderService.displayLoader(false);
              }

          });
      return event;
 }


searchTransaction(text, id, order, event) {
      var order;
      this.column="";
      if (text) {
          this.column = text;
      }
      if (id !== '') {
          this.numberColumn = id;
      }
      var advertiserName = '';

      var i = 0;
      for (i = 0; i < 6; i++) {
          if (this.numberColumn != i) {
              this.sortingOrder[i] = true;
          }
      }
            advertiserName = this.advertiserNameSearch.trim();

      if (order) {
          this.order = order;
      }
      if (this.column == "") {
                if (advertiserName == '' || advertiserName == undefined) {
          this.column = "MCE.name";
                }
                else{
        this.column="CM.name";

                }
  }
     if (this.order == 'DESC') {
          this.sortingOrder[this.numberColumn] = false;
      } else {
          this.sortingOrder[this.numberColumn] = true;
      }
      //Serach section
      var startDate='';
      var endDate='';
      var type=0;
    
      if(this.startDate!=null) {
      if(this.startDate.formatted==undefined || this.startDate.formatted==undefined){
          startDate='';
        } else {
          startDate="&startAt="+this.startDate.formatted;
        }
      }
      if(this.endDate!=null) {
        if(this.endDate.formatted==undefined || this.endDate.formatted==undefined){
          endDate='';
        } else {
          endDate="&endAt="+this.endDate.formatted;
        }
      }
      type=this.campaignType;
    
      //End search section
      
      this.itemsTotalAdv = 0;
      var j = 0;
      this.page = event;
      this.errormessage = "";
      this.searchmessage = "";
      var token = this.localstorage.getStorage("token");
      if (advertiserName == '' || advertiserName == undefined) {
        this.nameSortText='MCE.name';
        this.dateSortText='transactionDate';
      } else {
        this.nameSortText='CM.name';
        this.dateSortText='transaction_date';
      }
      this.loaderService.displayLoader(true);
        this.shareService.CallDatawithToken("admin/getAllTransactions?currentSize=25&currentPage=" + event + "&sortColumn=" + this.column + "&sortOrder=" + this.order+"&q="+advertiserName+"&type="+type+startDate+endDate, null, token).subscribe((result) => {
              console.log(result.data);
              if (result.data) {
                  this.data = result.data;
                  this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
                    if(
                    (advertiserName !== '' || type !== 0 || startDate !== '' || endDate!== '')){
                           this.selectedAud ='';
                           this.downloadTransactionIds = [];
                           this.downloadExcelData =[];
                                            this.excelFlag=true;

                    }
                    // else{
                        this.dataModulation();
                           this.loaderService.displayLoader(false);
   
                    // }

              }

          });
      return event;
 }


  formatDate(date) {

      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
  }

   openPost(url, variables){
           var token = this.localstorage.getStorage("token");

        var form = document.createElement("form");
        form.setAttribute("method", "get");
        form.setAttribute("action", url);
        form.setAttribute("target", "_self");

var header = document.createElement("input");
header.setAttribute("name","Authorization");
header.setAttribute("value", token);
form.appendChild(header);
var v;

for(v in variables){
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("name", v);
            hiddenField.setAttribute("value", variables[v]);
            form.appendChild(hiddenField);
}
        console.log(form);
        document.body.appendChild(form);

        form.submit();
    }
  generatePDF() {
    var token = this.localstorage.getStorage("token");
    var campaignIds=this.downloadTransactionIds.join();

window.location.href = this.shareService.apiUrl+"master/generatePdf?campaignIds="+campaignIds+"&token="+token;

  this.downloadTransactionIds=[];
                  this.pdfFlag=true;
                                    this.excelFlag=true;

          this.downloadExcelData=[];

         this.dataModulation();

 }
  changeSelect(id,check,data) {

      if(check) {
            this.downloadTransactionIds.push(id);
            this.downloadExcelData.push(data);
      } else {
          let index = this.downloadTransactionIds.findIndex(x => x==id);
          this.downloadTransactionIds.splice(index, 1);
          this.downloadExcelData.splice(index, 1);
      }

      if(this.downloadTransactionIds.length > 0 && this.selectedAud !== "all") {
            this.pdfFlag=false;
      } else {
        this.pdfFlag=true;
      }
      if(this.downloadExcelData.length>0){
          this.excelFlag = false
      }
      else{
                 this.excelFlag=true;
 
      }
  }

    targetTransactions(text){
                              var token = this.localstorage.getStorage("token");

        this.excelFlag=true;
this.downloadExcelData =[];
this.downloadTransactionIds =[];
      if(text == "all"){
 var advertiserName = '';
       advertiserName = this.advertiserNameSearch.trim();
 var startDate='';
      var endDate='';
    
      if(this.startDate!=null) {
      if(this.startDate.formatted==undefined || this.startDate.formatted==undefined){
          startDate='';
        } else {
          startDate="&startAt="+this.startDate.formatted;
        }
      }
      if(this.endDate!=null) {
        if(this.endDate.formatted==undefined || this.endDate.formatted==undefined){
          endDate='';
        } else {
          endDate="&endAt="+this.endDate.formatted;
        }
      }
                    this.loaderService.displayLoader(true);
  if (this.column == "") {
                if (advertiserName == '' || advertiserName == undefined) {
          this.column = "MCE.name";
                }
                else{
        this.column="CM.name";

                }
  }
        this.shareService.CallDatawithToken("admin/getAllTransactions?currentSize="+this.itemsTotalAdv+"&currentPage=1&sortColumn=" + this.column + "&sortOrder=" + this.order+"&q="+advertiserName+"&type="+this.campaignType+startDate+endDate, null, token).subscribe((result) => {
      var i=0;
       setTimeout(() => {

      if (result.data) {
          for(i=0;i<result.data.length;i++){
            this.downloadExcelData.push(result.data[i]);
this.downloadTransactionIds.push(result.data[i].campaignModel.id);
          }
      }
                        this.dataDownload(text);

           this.loaderService.displayLoader(false);

          }, 2000);
    });
              this.pdfFlag = true;
    this.selectedAud = "all";
           this.excelFlag=false;

      }
      else if(text === "select"){
                                  this.dataDownload(text);
              this.pdfFlag = true;
           this.excelFlag=true;

                   this.selectedAud = "select";
                this.loaderService.displayLoader(false);

      }
      else{
         this.selectedAud = "";  
                    this.loaderService.displayLoader(false);

      }

  }

  dataDownload(text){
          console.log(this.downloadTransactionIds);

      var i=0;
      var j=0;
for(i=0;i<this.data.length;i++){
    if(text ==="all"){
  
    this.disabledCheckValue[this.data[i].campaignModel.id ] = true;

    }
else{
    console.log("else");
    this.disabledCheckValue[this.data[i].campaignModel.id ] = false;

}
}
  }
 dataModulation(){
    var i=0;
    var j=0;
    console.log(this.data);
  for(i=0;i<this.data.length;i++){
    if(this.downloadTransactionIds.length>0) {
    for(j=0;j<this.downloadTransactionIds.length;j++){
  if(this.data[i].campaignModel.id == this.downloadTransactionIds[j]){
      
    this.disabledCheckValue[this.data[i].campaignModel.id ] = true;
  } 
    }
} else {
    this.disabledCheckValue[this.data[i].campaignModel.id ] = false;
}

      }


  }
  changeText(event=null,fDate=null) {
    var sdate='';
    var edate='';
    if(fDate=='start'){
        if(event!=null){
            sdate=event.formatted;
        } else {
            sdate=this.startDate;
        }
    }
    if(fDate=='end'){
        if(event!=null){
            edate=event.formatted;
        } else {
            edate=this.endDate;
        }
    }
    if(this.advertiserNameSearch=='' && this.campaignType==0 && (sdate==null || sdate=='') && (edate==null || edate=='')) {
        this.searchBtn=true;
      } else {
        this.searchBtn=false;
      }
  }

  

  excelDownload(){

      var data = [];
      data[0]={
        'S No':'S No',  
        'Transaction Number':'Transaction Number',
        'Advertiser Name':'Advertiser Name',
        'Transaction Date':'Transaction Date',
        'Campaign Type':'Campaign Type',
        'Total Amount Paid (AUD)':'Total Amount Paid (AUD)',
        'Campaign Status':'Campaign Status'
      };
      var i:any=1;
 this.downloadExcelData.forEach((value,key) => {

            var excelData={}; 
            excelData['S No']=i;
            excelData['Transaction Number']=value.campaignModel.id;
            excelData['Advertiser Name']=value.campaignModel.advertiserInfo.companyName;
            excelData['Transaction Date']=this.formatDate(value.transactionDate);
            excelData['Campaign Type']=value.campaignModel.type;
            excelData['Total Amount Paid (AUD)']=(Math.round(value.amountDeducted * 100) / 100).toFixed(2);
            excelData['Campaign Status']=value.campaignModel.status;
            data.push(excelData);
            i++;
      });
      this.pdfFlag=true;
      this.downloadTransactionIds=[];
      this.dataModulation();
           this.selectedAud = "";
                                    this.excelFlag=true;

      this.downloadExcelData=[];
      var options={};
     // return new Angular2CsvModule(data, 'TransactionReport', options);
    // return new  Angular2Csv(data, 'TransactionReport', options);
      new ngxCsv(data, 'TransactionReport', options);
      // new Angular2CsvModule(data, 'TransactionReport',);
     
  }
}


// WEBPACK FOOTER //
// ./src/app/admin/layout/transactions/transactions.component.ts